import { render, staticRenderFns } from "./ListaOrcamentosPedidos.vue?vue&type=template&id=0e621162"
import script from "./ListaOrcamentosPedidos.vue?vue&type=script&lang=js"
export * from "./ListaOrcamentosPedidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports